import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Button } from '@/components/ui/button';
import { LayoutDashboard, Building2, Ticket, LogOut, Home, Menu, X, BarChart3 } from 'lucide-react';
import { useState } from 'react';

const AdminSidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/admin');
  };

  const navItems = [
    { path: '/admin/dashboard', label: 'Panel de Control', icon: LayoutDashboard },
    { path: '/admin/empresas', label: 'Empresas', icon: Building2 },
    { path: '/admin/cupones', label: 'Cupones', icon: Ticket },
    { path: '/admin/estadisticas', label: 'Estadísticas', icon: BarChart3 },
  ];

  const isActive = (path) => location.pathname === path;

  const NavContent = ({ isMobile = false }) => (
    <>
      {/* Logo */}
      <div className="p-6 border-b border-white/10">
        <Link to="/" className="flex items-center gap-3 text-white">
          <img 
            src="https://customer-assets.emergentagent.com/job_619dfbd9-e9ac-4905-ae17-ad2e8903622d/artifacts/ibo9k545_LOGO%20CLUB%20CA%CC%81MARA%20%2B%20SIN%20FONDO.png" 
            alt="Club Cámara Lanzarote" 
            className="h-12 w-auto"
          />
        </Link>
      </div>

      {/* Navigation */}
      <nav className="flex-grow p-4 space-y-1">
        {navItems.map(item => (
          <Link
            key={item.path}
            to={item.path}
            onClick={() => setMobileOpen(false)}
            className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-all ${
              isActive(item.path)
                ? 'bg-white/20 text-white'
                : 'text-white/70 hover:bg-white/10 hover:text-white'
            }`}
            data-testid={`${isMobile ? 'mobile-' : ''}nav-${item.path.split('/').pop()}`}
          >
            <item.icon className="w-5 h-5" />
            <span className="font-medium">{item.label}</span>
          </Link>
        ))}
      </nav>

      {/* Footer Actions */}
      <div className="p-4 border-t border-white/10 space-y-2">
        <Link
          to="/"
          className="flex items-center gap-3 px-4 py-3 rounded-lg text-white/70 hover:bg-white/10 hover:text-white transition-all"
          data-testid={`${isMobile ? 'mobile-' : ''}nav-view-site`}
        >
          <Home className="w-5 h-5" />
          <span className="font-medium">Ver Sitio</span>
        </Link>
        <Button
          variant="ghost"
          className="w-full justify-start gap-3 px-4 py-3 h-auto text-white/70 hover:bg-white/10 hover:text-white"
          onClick={handleLogout}
          data-testid={`${isMobile ? 'mobile-' : ''}logout-btn`}
        >
          <LogOut className="w-5 h-5" />
          <span className="font-medium">Cerrar Sesión</span>
        </Button>
      </div>
    </>
  );

  return (
    <>
      {/* Mobile Toggle Button */}
      <button
        className="md:hidden fixed top-4 left-4 z-50 p-2 bg-[#00509D] text-white rounded-lg shadow-lg"
        onClick={() => setMobileOpen(!mobileOpen)}
        data-testid="mobile-menu-toggle"
      >
        {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
      </button>

      {/* Mobile Overlay */}
      {mobileOpen && (
        <div 
          className="md:hidden fixed inset-0 bg-black/50 z-40"
          onClick={() => setMobileOpen(false)}
        />
      )}

      {/* Mobile Sidebar */}
      <aside className={`
        md:hidden fixed inset-y-0 left-0 z-50 w-64 admin-sidebar flex flex-col transform transition-transform duration-300
        ${mobileOpen ? 'translate-x-0' : '-translate-x-full'}
      `}>
        <NavContent isMobile={true} />
      </aside>

      {/* Desktop Sidebar */}
      <aside className="hidden md:flex admin-sidebar flex-col">
        <NavContent isMobile={false} />
      </aside>
    </>
  );
};

export default AdminSidebar;
